export default __webpack_public_path__ + "static/media/pictogramBeaconBranch128.3cf34048.svg";